import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { platformAuthService } from '../../services/platformApi';

const PlatformProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = platformAuthService.getToken();

  if (!token) {
    return <Navigate to="/platform/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default PlatformProtectedRoute;
